import { guessMusicMetadata } from "./musicClass";

type Song = { title: string; artist: string };
type Match = { trackName: string; artistName: string; duration: number; syncedLyrics: string };
const normalize = (text: string) => text.toLowerCase().replace(/[^\p{L}\p{N}]/gu, "");
const musicVideo = (text: string) => /\b(?:official(?:\s+music)?\s+video|music\s+video)\b/i.test(text) && !/\blyrics?\b/i.test(text);

/** A matching song name does not establish timing for a music video's intro/edit. */
export function chooseMusicLyrics<T extends Match>(song: Song, matches: T[], videoTitle = "", videoDuration = 0): T | null {
    const sameSong = matches.filter(match => {
        const candidate = guessMusicMetadata(match.trackName, match.artistName);
        return normalize(match.artistName) === normalize(song.artist) && normalize(candidate.title) === normalize(song.title);
    });
    const isVideo = musicVideo(videoTitle);
    // For an explicit music video, prefer records for that version, even when an
    // album record happens to claim the same duration. Otherwise ask the teacher.
    const candidates = sameSong.filter(match => isVideo ? musicVideo(match.trackName) : !musicVideo(match.trackName));
    return [...candidates].sort((a, b) => {
        const exactUpload = (match: T) => videoTitle && normalize(match.trackName) === normalize(videoTitle) ? 1 : 0;
        const exact = exactUpload(b) - exactUpload(a); if (exact) return exact;
        if (videoDuration > 0) {
            const duration = Math.abs(a.duration - videoDuration) - Math.abs(b.duration - videoDuration);
            if (Math.abs(duration) > 0.5) return duration;
        }
        return Number(!!b.syncedLyrics) - Number(!!a.syncedLyrics);
    })[0] ?? null;
}
